module.exports = __webpack_public_path__ + "static/img/anli4.7ada3c6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli4.gif
// module id = Z1jR
// module chunks = 1